import { render, staticRenderFns } from "./HeaderLandingNew.vue?vue&type=template&id=5894b410&scoped=true"
import script from "./HeaderLandingNew.vue?vue&type=script&lang=js"
export * from "./HeaderLandingNew.vue?vue&type=script&lang=js"
import style0 from "../../../styles/header-landing-new.scss?vue&type=style&index=0&id=5894b410&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5894b410",
  null
  
)

export default component.exports